export const GOLFER_INTAKE_SECTIONS = [
  {
    id: 'golfer-info',
    label: 'Golfer info',
    pageTitle: 'Golfer information',
    fields: [
      'golfInformation.frequency',
      'golfInformation.associatedWithCourse',
      'golfInformation.homeGolfCourse',
      'golfInformation.proficiency',
      'golfInformation.ownClubs',
      'golfInformation.handedness',
      'golfInformation.handicapRating',
      'golfFocusInformation.confidentArea',
      'golfFocusInformation.improvementArea',
    ],
  },
  {
    id: 'physical-info',
    label: 'Physical Info',
    pageTitle: 'Physical information',
    fields: [
      'physicalInformation.heightFeet',
      'physicalInformation.heightInches',
      'physicalInformation.limitations',
    ],
  },
]

export const getGolferIntakeSectionIndex = sectionId =>
  Math.max(
    0,
    GOLFER_INTAKE_SECTIONS.findIndex(section => section.id === sectionId),
  )
